export default __webpack_public_path__ + "static/media/fw-adele-er-Rose Gold.3268203b.mp4";